import type { SubscriptionType } from '@/@types/Subscription';
import type { CatalogSection, Periodicity } from '@/shared/catalog/types';
import { isYearlyPeriodicity } from '@/shared/plans';
import { isInvoicingPlanSlug } from '@/features/invoicing/v2/lib/quota';

/**
 * Which plans a subscription can change to, in catalog terms: the same family
 * (declarations with declarations, invoicing with invoicing) and the same
 * periodicity, as the engine allows in phase 1. The engine re-checks both.
 */

export const isInvoicingSubscription = (subscription?: SubscriptionType | null) =>
	isInvoicingPlanSlug(subscription?.product_version?.product?.slug);

export const catalogSectionOf = (subscription: SubscriptionType): CatalogSection =>
	isInvoicingSubscription(subscription) ? 'invoicing' : 'subscriptions';

export const periodicityOf = (subscription: SubscriptionType): Periodicity =>
	isYearlyPeriodicity(subscription.product_version?.periodicity) ? 'annual' : 'monthly';
